let requisitionLineSequence = 0;

export function createRequisitionLineKey() {
  requisitionLineSequence += 1;
  return `rq-line-${Date.now()}-${requisitionLineSequence}`;
}

export function withRequisitionLineKey(line = {}) {
  if (line._clientKey) return line;
  return { ...line, _clientKey: createRequisitionLineKey() };
}

export function findRequisitionLineByKey(lines = [], lineKey) {
  return lines.find((line) => line?._clientKey === lineKey) || null;
}

export function updateRequisitionLineByKey(lines = [], lineKey, patchOrFn) {
  let changed = false;
  const nextLines = lines.map((line) => {
    if (line?._clientKey !== lineKey) return line;
    changed = true;
    return typeof patchOrFn === "function"
      ? patchOrFn(line)
      : { ...line, ...patchOrFn };
  });
  return changed ? nextLines : lines;
}

